(function(){
  function parse(v){return v?Date.parse(String(v).trim().replace(' ','T')):NaN}
  function pct(el){
    var now=Date.now(),s=parse(el.dataset.start),e=parse(el.dataset.end);
    if(!isNaN(s)&&!isNaN(e)&&e>s){if(now>=e)return -1;if(now<s)return .08;return (now-s)/(e-s)}
    var c=(+el.dataset.cycle||24)*36e5;return (now%c)/c;
  }
  function paint(el){
    var p=pct(el);if(p<0){el.hidden=true;return}
    el.hidden=false;
    var f=el.querySelector('.d22-offer__fill');
    if(f) f.style.transform='scaleX('+Math.min(.97,Math.max(.08,p)).toFixed(3)+')';
  }
  function place(el){
    if(el.dataset.placed) return;
    var c=document.querySelector('.product__info-container'); if(!c) return;
    var a=c.querySelector('.product-form__quantity,product-form,.product-form');
    while(a&&a.parentElement!==c) a=a.parentElement;
    if(a){c.insertBefore(el,a);el.dataset.placed='1'}
  }
  function init(){
    document.querySelectorAll('[data-d22-offer]').forEach(function(el){
      place(el);
      requestAnimationFrame(function(){paint(el)});
      if(!el._t) el._t=setInterval(function(){paint(el)},60000);
    });
  }
  init();
  document.addEventListener('shopify:section:load',init);
})();
